<template>
  <div class="container">
    <Header></Header>
    <div class="blank">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/pc/images/index/logo.png" alt=""/>
        </router-link>
      </div>
    </div>
    <TabBar :hideSecondMenu="true"></TabBar>
    <!-- <ReferenceHead></ReferenceHead> -->
    <div class="content">
      <div class="bread">
        <IndexCategory bgColor="#fff" :showIndex="false">
          <!-- <li>当前位置</li> -->
          <!-- <li @click="$router.go('/referenceIndex')">首页</li> -->
          <li><router-link to="/">首页</router-link></li> 
          <!-- <li>查询中心</li> -->
          <li>参比制剂目录</li>
        </IndexCategory>
      </div>
      <div class="input-box">
        <div class="search">
          <input
            type="text"
            v-model="q.keyword"
            placeholder="请输入药品通用名查询对应参比制剂"
            class="search-input"
          />
          <button @click="searchVal">搜索</button>
        </div>
      </div>
      <div class="result">
        <div class="result-title">热门参比制剂目录</div>
        <table>
          <thead>
            <th>药品通用名称</th>
            <th>英文名称/商品名</th>
            <th>规格</th>
            <th>剂型</th>
            <th>持证商</th>
            <th>备注1</th>
            <th>操作</th>
          </thead>
          <tbody>
            <tr v-for="item of referencesList" :key="item.No">
              <td>{{ item.general_name }}</td>
              <td>{{ item.english_name }}</td>
              <td>{{ item.size }}</td>
              <td>{{ item.form }}</td>
              <td>{{ item.holder }}</td>
              <td>{{ item.remark1 }}</td>
              <td>
                <span @click="maskShow = true">采购</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="no-data" v-if="totalNum === 0">
          未查询到对应数据，请更换关键词再进行搜索！
        </div>
        <div class="page-content" v-if="totalNum > 20">
          <Page
            :total="totalNum"
            :page-size="20"
            @on-change="changePage"
          ></Page>
        </div>
      </div>
    </div>
    <ReferenceMask :maskShow="maskShow" @close="close"></ReferenceMask>
  </div>
</template>

<script>
import ReferenceHead from "@/components/pc/reference/ReferenceHead";
import IndexCategory from "@/components/pc/nav/IndexCategory";
import ReferenceMask from "@/components/pc/reference/ReferenceMask";
import Header from "@/components/pc/header/Header";
import TabBar from "@/components/pc/nav/TabBar";
import { getReferences } from "@api/public";
export default {
  name: "ReferencePreparation",
  components: {
    IndexCategory,
    ReferenceHead,
    ReferenceMask,
    Header,
    TabBar
  },
  data() {
    return {
      q: {
        page: 1,
        limit: 20,
        keyword: ""
      },
      referencesList: [],
      totalNum: 0,
      maskShow: false
    };
  },
  created() {
    this.q.keyword = this.$route.query.word || "";
    this.getReferencesList();
  },
  methods: {
    getReferencesList() {
      getReferences(this.q).then(res => {
        this.referencesList = res.data;
        this.totalNum = Number(res.msg);
      });
    },
    changePage(index) {
      this.q.page = index;
      this.getReferencesList();
    },
    searchVal() {
      this.getReferencesList();
    },
    close() {
      this.maskShow = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  background #fff
  .blank
    padding 60px 0
    margin 20px auto
    width 600px
    position relative
    .logo
      position absolute
      width 100px
      height 50px
      left -300px
      width 200px
      img
        width 100%
  .content
    width 1200px
    margin 0px auto 0
    .bread
      margin-left -35px
    .input-box
      padding 30px 0
      .search
        display flex
        justify-content center
        .search-input
          width 600px
          height 50px
          border 2px solid #4496ee
          padding-left 20px
          font-size 16px
        button
          width 115px
          height 50px
          background #4496ee
          color #fff
          font-size 16px
          cursor pointer
    .result
      padding-bottom 20px
      .result-title
        padding-left 10px
        margin-bottom 20px
        color #0d8cca
        position relative
        font-size 20px
        &::before
          content ''
          display inline-block
          position absolute
          height 18px
          width 3px
          background #0d8cca
          left 0
          top 6px
      table
        border-collapse collapse
        th
        td
          border 1px solid #d6d6d6
          text-align center
          color #666
          line-height 20px
          &:nth-child(2)
            width 200px
          &:last-child
            width 80px
        th
          line-height 50px
          background #d6ebf8
          font-size 16px
          font-weight 700
        td
          height 76px
          >span
            display block
            width 36px
            background #4496ee
            margin 0 auto
            color #fff
            border-radius 3px
            cursor pointer
      .no-data
        height 80px
        line-height 80px
        text-align center
        font-size 18px
        color #555
      .page-content
        display flex
        margin-top 20px
        flex-direction row-reverse
</style>
